import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { faqData } from "../data/mock";

export const FaqSection = () => {
  return (
    <section className="py-24 lg:py-32 bg-[#0A0A0A] relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#F76B1C]/[0.01] rounded-full blur-[160px]" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14 lg:mb-16">
          <span className="text-[#F76B1C] text-sm font-semibold uppercase tracking-[0.15em]">
            FAQ
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
            Frequently Asked Questions
          </h2>
          <p className="mt-6 text-lg text-white/45 leading-relaxed">
            Everything you need to know about Formlabs SLA printers, resins,
            and buying from 3D Printer Gear.
          </p>
        </div>

        {/* Accordion */}
        <Accordion type="single" collapsible className="space-y-3">
          {faqData.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="rounded-xl bg-[#111111] border border-white/[0.06] px-6 lg:px-7 data-[state=open]:border-[#F76B1C]/20 transition-colors duration-300"
            >
              <AccordionTrigger className="text-left text-[15px] lg:text-base font-semibold text-white/80 hover:text-white py-5 hover:no-underline [&[data-state=open]]:text-[#F76B1C]">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-white/45 leading-relaxed pb-5">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <p className="text-white/30 text-sm mb-3">
            Still have questions?
          </p>
          <a
            href="tel:1300334327"
            className="text-[#F76B1C] hover:text-[#FF8C42] font-semibold text-sm transition-colors"
          >
            Call us on 1300 334 327
          </a>
        </div>
      </div>
    </section>
  );
};
